import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { PromotionsService } from 'src/app/features/promotions/promotions.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { ProvidersService } from '../providers.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-map-pricelist',
  templateUrl: './map-pricelist.component.html',
  styleUrls: ['./map-pricelist.component.scss'],
  providers: [CurrencyPipe]
})
export class MapPricelistComponent extends FeaturesBaseComponent implements OnInit, OnDestroy, OnChanges {
  @Input() loyalityRewardsData: [];
  @Input() codeGroups: [];
  @Input() tiers: [];
  @Input() countries: any[];
  @Input() pricelist: any[];
  @Input() salesreps: any[];
  isLoyaltyRewardsVisible: boolean = true;
  isLoyaltyEditVisible: boolean = false;
  rowSelection: string;
  searchValue;
  showEditPromotion: boolean = false;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  loyaltyRewardsForm: FormGroup;
  providers: any;
  loyaltyId: any;
  loyaltyRewardDetail: any;
  countriesList: any = [];
  submitLabel: string;
  formAction: string;
  isFormUpdate: boolean = false;
  codeGroupControl = new FormControl();
  tierControl = new FormControl('');  
  pointsControl = new FormControl('');
  countryControl = new FormControl('');
  amountControl = new FormControl('')
  @ViewChild('allSelected') private allSelected: MatOption;
  selectedcountriesList: any;
  applicableCountries: any;
  columnDefs: any;

  constructor(private currencyPipe: CurrencyPipe, private fb: FormBuilder, private router: Router, private promotionService: PromotionsService, private providersService: ProvidersService) {
    super();
    this.isLoyaltyRewardsVisible = false;
    this.isLoyaltyEditVisible = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['countries']) {
      this.countries = changes['countries'].currentValue;
    }
    if (changes['tiers']) {
      this.tiers = changes['tiers'].currentValue;
    }
    this.countriesList = []
    this.countries.forEach(element => {
      this.countriesList.push(element)
    });

  }
  ngOnInit(): void {
    this.initiateForm();
  }


  initiateForm = () => {
    this.loyaltyRewardsForm = new FormGroup({
      codeGroup: this.codeGroupControl,
      country: this.countryControl
    })
  }

  get f() {
    return this.loyaltyRewardsForm.controls;
  }

  return() {
    this.isLoyaltyEditVisible = true;
    this.loyaltyRewardsForm.reset();
    return
  }

  //no use
  editPromotions() {
    this.formAction = 'pages.placeholders.Edit';
    this.submitLabel = 'pages.placeholders.Update';
    this.isFormUpdate = true;
    this.loyaltyId = this.selectedRows[0].loyaltyId;
   

    if (this.loyaltyId && this.loyaltyId) {
      this.promotionService.getLoyaltyRewardsDataById(this.loyaltyId)
        .subscribe(res => {
          this.loyaltyRewardDetail = res['data']
          this.fillLoyaltyForm(this.loyaltyRewardDetail)
        }
        );
      this.isLoyaltyEditVisible = true;
      this.isLoyaltyRewardsVisible = false;
    }
  }
  addPromotionConfig() {
    this.formAction = 'pages.placeholders.Add';
    this.submitLabel = 'pages.placeholders.Save';
    this.isFormUpdate = false;
    this.isLoyaltyEditVisible = true;
    this.isLoyaltyRewardsVisible = false;
  }

  fillLoyaltyForm(loyaltyRewardDetail: any) {
    
    this.loyaltyRewardsForm.get('codeGroup').setValue(loyaltyRewardDetail.codeGroup)
    this.loyaltyRewardsForm.get('tier').setValue(loyaltyRewardDetail.tier)
    this.loyaltyRewardsForm.get('points').setValue(loyaltyRewardDetail.pointsAccumulated)
    
    let _applicableCountries: any = [];
    loyaltyRewardDetail.applicableCountries.forEach(element => {
      _applicableCountries.push(element.trim())
      if (loyaltyRewardDetail.applicableCountries.length == _applicableCountries.length) {
        this.loyaltyRewardsForm.get('country').setValue(_applicableCountries)
        this.applicableCountries = _applicableCountries
      }
    });
    this.loyaltyRewardsForm.get('amount').setValue(loyaltyRewardDetail.amountOfRecharge)
  }

  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.showEditPromotion = true;
      return
    }
    this.showEditPromotion = false;
    //edit-loyality
  }

  

  getLoyaltyRewardsData() {
    this.promotionService.getAllLoyaltyRewards().subscribe(res => {
      
      this.loyalityRewardsData = res['data'];
      this.gridApi.refreshCells();

    });
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onCancel() {
    this.return()

  }
  tosslePerOne(all){ 
    if (this.allSelected.selected) {  
     this.allSelected.deselect();
     return false;
 }
   if(this.countryControl.value.length==this.countriesList.length)
     this.allSelected.select();
 } 
  toggleAllSelection() {
    if (this.allSelected.selected) {
      //;
      //;
      //;
      //
      this.countryControl.patchValue([...this.countriesList.map(item => item), 0]);
      //
    } else {
      this.countryControl.patchValue([]);
    }
  }
  
  getCountryNames(e){
    let codegroup = this.loyaltyRewardsForm.get('codeGroup').value;
    let tier = this.loyaltyRewardsForm.get('tier').value;
    this.promotionService.getCountryNames(codegroup,tier).subscribe(res => {
      let resData: any = res;
      this.selectedcountriesList = [];
      if (resData.httpcode == 200) {
        resData = resData.data;
        resData.forEach(element => {
          this.selectedcountriesList.push(element);
        });
        //;
      }
    })
  }
  onSelected(e: MatSelectChange) {
    let __pricelist = e.value;
    this.loyaltyRewardsForm.get('country').setValue([])
    this.providersService.getmappedPricelists(this.loyaltyRewardsForm.get('codeGroup').value).subscribe(
      res =>{ 
       
        //let dummy = ["Rate Plan 1 Low No SP","Rate Plan 1 Low","Rate Plan 1 California","Rate Plan 2 Commission","Rate Plan 2 California","Rate Plan 2","Rate Plan 2 Low","Rate Plan 1 Commission","Rate Plan 1 Commission (Retailer)","abcd","Rate Plan 3 Commission"];
        //res['data'] = dummy;
        let _applicableCountries: any = [];
        this.applicableCountries = [];
        res['data'].forEach(element => {
      _applicableCountries.push(element)
      if (res['data'].length == _applicableCountries.length) {
        this.loyaltyRewardsForm.get('country').setValue(_applicableCountries)
        this.applicableCountries = _applicableCountries
      }
    });
      
      })  
  }
  onLoyaltyFormSubmit(){
    //;
    if (!this.loyaltyRewardsForm.valid) {
      return;
    }
    //if (this.isFormUpdate) {        
      let selectdlist = this.loyaltyRewardsForm.get('country').value
      this.providersService.getmappedPricelists(this.loyaltyRewardsForm.get('codeGroup').value).subscribe(res => {
        let resData: any = res;
        this.selectedcountriesList = [];
        if (resData.httpcode == 200) {
          resData = resData.data;
          resData.forEach(element => {
            this.selectedcountriesList.push(element);
          });

          let _countries:any= [];
          let _countriesfrom:any= [];
      
          selectdlist.forEach(element => {
           
            if(element != 0){
              
              if(this.selectedcountriesList.indexOf(element) !== -1) {
                if(this.applicableCountries.indexOf(element) !== -1) {
                
                }else{
                  _countriesfrom.push(element)
                }
              }
              _countries.push(element)
              
            }  
          });   
            if(_countriesfrom.length > 0){ 
              this.toastrService.error('PriceList :  '+_countriesfrom , 'Error', {
                timeOut: 3000,
              });
              return;
            }
           
            //
            //let _selectedRow = this.selectedRows[0];
            //if (_selectedRow.loyaltyId == this.loyaltyId) {
              let params = {
                "applicableCountries": _countries,
                "codeGroup": this.loyaltyRewardsForm.get('codeGroup').value,
                
              }
      
              this.providersService.updatemappedPricelists(this.loyaltyRewardsForm.get('codeGroup').value,_countries).subscribe(
                res => {
                  if (res['responseStatus'] == 'Success' && res['httpcode'] == 200) {
      
                    this.toastrService.success('Updated Successfully', 'Success', {
                      timeOut: 3000,
                    }); 
                    this.getLoyaltyRewardsData();
                  }
                }
              )
              this.reloadComponent();
             
            //}
            return

          //;
        }
      })
      
      return
    //}   
  }
  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }    
}
 